'use strict';

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _toArray(arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var optional = require('@bit/bit.utils.string.optional');

var NpmId = require('@bit/bit.javascript.component.npm-id');

var BIT_REGISTRY = 'bit';
var NPM_SEPARATOR = '.';
var BIT_NAMESPACE_SEPARATOR = '/';
var BIT_SCOPE_SEPARATOR = '.'; // owner.scope/fullName

var bitIdRegex = /^([^./@]+)\.([^./@]+)(\/([^.@]+))(@([^@]*))?$/; // /owner/scope/fullName

var urlIdRegex = /^\/?([^./@]+)\/([^./@]+)(\/([^.@]*))$/;
var VERSION_QUERY_PARAM = 'version';
var VERSION_PATH_PARAM = 'v';
/**
 * @name BitNameId
 * @example BitNameId.fromBitId('bit.utils/string/optional');
 */

var BitId = function () {
  _createClass(BitId, [{
    key: 'registry',

    /**
     * @property {string} registry - all bit components will have the "bit" as registry (compatible with NpmIds)
     */

    /**
     * @property {string} [scopeId] - alternative representation of owner + scope names. Used in specific methods with the overrideOwnerScopeWithScopeid flag.
     */
    get: function get() {
      return BIT_REGISTRY;
    }
    /**
     * @name construtor
     * @description initialize class to handle bitIds
     * @param {string} owner
     * @param {string} scope
     * @param {string[]} fullName
     * @param {string} name
     * @param {string} version
     * @example const parsedBitId = new BitId('uri', 'kutorg', 'component/is-string', '1.0.0');
     */

  }]);

  function BitId(owner, scope) {
    var fullName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var version = arguments[3];

    _classCallCheck(this, BitId);

    this.owner = owner;
    this.scope = scope;
    this.fullName = !!fullName ? typeof fullName === 'string' ? fullName.split(BIT_NAMESPACE_SEPARATOR) : fullName : [];
    this.version = version;
  }
  /**
   * @name toNpmId
   * @description create npm id
   * @param {Object} options
   * @param {boolean} [options.includeVersion] - includes '@x.x.x' at the end of the result
   * @param {boolean} [options.includeFilePath] - includes '/dist/file.js' at the end of the result
   * @param {boolean} [options.includeRegistry] - includes '@bit/' registry at the start of the result
   * @param {boolean} [options.includePrefix] - DEPRECATED includes '@bit/' registry at the start of the result
   */


  _createClass(BitId, [{
    key: 'toNpmId',
    value: function toNpmId() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var version = this.version,
          filePath = this.filePath; //backward compatability for .includePrefix:

      if (options.includeRegistry === undefined && options.includePrefix !== undefined) {
        options.includeRegistry = options.includePrefix;
      }

      ;
      var fullName = [optional('', this.getFullScopeName(NPM_SEPARATOR), NPM_SEPARATOR), this.getFullName(NPM_SEPARATOR)].join('');
      var npmId = new NpmId(fullName, version);
      npmId.registry = BIT_REGISTRY;
      npmId.filePath = filePath;
      return npmId.toNpmId(options);
    }
    /**
     * @name toBitId
     * @description create bitId
     */

  }, {
    key: 'toBitId',
    value: function toBitId() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeVersion = _ref.includeVersion,
          includeVersion = _ref$includeVersion === undefined ? true : _ref$includeVersion;

      var version = this.version;
      if (!this.getFullName()) return undefined;
      var segments = [optional('', this.getFullScopeName(BIT_SCOPE_SEPARATOR), BIT_NAMESPACE_SEPARATOR), this.getFullName(BIT_NAMESPACE_SEPARATOR), optional('@', includeVersion && version)];
      return segments.join('');
    }
    /**
     * @param {Object} [options]
     * @param {boolean} [options.overrideOwnerScopeWithScopeid] - replace owner + scope names with the hashed scopeId
     */

  }, {
    key: 'toUrl',
    value: function toUrl() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$overrideOwnerSc = _ref2.overrideOwnerScopeWithScopeid,
          overrideOwnerScopeWithScopeid = _ref2$overrideOwnerSc === undefined ? false : _ref2$overrideOwnerSc;

      var owner = this.owner,
          scope = this.scope,
          scopeId = this.scopeId,
          fullName = this.fullName;
      var segments = [];
      if (overrideOwnerScopeWithScopeid) segments.push(scopeId);else segments.push(owner, scope);
      segments.push.apply(segments, _toConsumableArray(fullName));
      return segments.join('/');
    }
    /**
     * @name toQueryParams
     * @param {Object} [options]
     * @param {boolean} [options.withVersion=true] - add version to query param
     * @returns string
     */

  }, {
    key: 'toQueryParams',
    value: function toQueryParams() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$withVersion = _ref3.withVersion,
          withVersion = _ref3$withVersion === undefined ? true : _ref3$withVersion;

      var version = this.version;
      return [withVersion && optional(VERSION_QUERY_PARAM + '=', version)].filter(function (x) {
        return !!x;
      }).join('&');
    }
    /**
     * @name toPathParams
     * @param {Object} [options]
     * @param {boolean} [options.withVersion=true] - add version to query param
     * @returns string
     */

  }, {
    key: 'toPathParams',
    value: function toPathParams() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$withVersion = _ref4.withVersion,
          withVersion = _ref4$withVersion === undefined ? true : _ref4$withVersion;

      var version = this.version;
      return [withVersion && optional('~' + VERSION_PATH_PARAM + '=', version)].filter(function (x) {
        return !!x;
      }).join('/');
    }
    /**
     * @name getFullName
     * @param {string} separator - add version to query param
     * @returns string
     */

  }, {
    key: 'getFullName',
    value: function getFullName() {
      var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
      var fullName = this.fullName;
      return [].concat(fullName).join(separator);
    }
    /**
     * @name getFullScopeName
     * @returns string
     */

  }, {
    key: 'getFullScopeName',
    value: function getFullScopeName() {
      var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BIT_SCOPE_SEPARATOR;
      var owner = this.owner,
          scope = this.scope;
      return [owner, scope].join(separator);
    }
  }, {
    key: 'nameSpace',
    get: function get() {
      var fullName = this.fullName;
      return fullName.slice(0, -1);
    }
  }, {
    key: 'name',
    get: function get() {
      var fullName = this.fullName; // const len = fullName.length;

      return fullName.slice(-1).pop();
    }
    /**
     * @name fromNpmId
     * @param {boolean} withVersion - add version to query param
     * @param {boolean} [options.enforceScopedBitRegistry]
     * @returns BitId
     */

  }], [{
    key: 'fromNpmId',
    value: function fromNpmId(id) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$enforceScopedBi = _ref5.enforceScopedBitRegistry,
          enforceScopedBitRegistry = _ref5$enforceScopedBi === undefined ? true : _ref5$enforceScopedBi,
          _ref5$allowFallbackTo = _ref5.allowFallbackToNpm,
          allowFallbackToNpm = _ref5$allowFallbackTo === undefined ? false : _ref5$allowFallbackTo;

      if (allowFallbackToNpm && !enforceScopedBitRegistry) {
        throw new Error('illegal parameters combination: { allowFallbackToNpm: true, enforceScopedBitRegistry: false }');
      }

      var npmId = NpmId.fromNpmId(id);
      if (!npmId) return undefined;
      var registry = npmId.registry,
          name = npmId.name,
          version = npmId.version,
          filePath = npmId.filePath;
      if (!name) return undefined;

      if (enforceScopedBitRegistry && registry !== BIT_REGISTRY) {
        if (allowFallbackToNpm) return npmId;
        return undefined;
      }

      var _name$split = name.split(NPM_SEPARATOR),
          _name$split2 = _toArray(_name$split),
          owner = _name$split2[0],
          scope = _name$split2[1],
          fullName = _name$split2.slice(2);

      if (!owner || !scope || fullName.length === 0) return undefined;
      var instance = new BitId(owner, scope, fullName, version);
      instance.filePath = filePath;
      return instance;
    }
    /**
     * @name fromUrl
     * @param {string} id - represents component url
     * @param {QueryParams} queryParams - add version to query param
     * @returns BitId
     */

  }, {
    key: 'fromUrl',
    value: function fromUrl(id) {
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var parsed = urlIdRegex.exec(id);
      if (!parsed) return undefined;

      var _parsed = _slicedToArray(parsed, 5),
          //match 0
      owner = _parsed[1],
          //group 1
      scope = _parsed[2],
          //group 2
      box = _parsed[4];

      var fullName = (box || '').split('/');
      return new BitId(owner, scope, fullName, queryParams.version);
    }
    /**
     * @name fromBitId
     * @description convert string to bitId
     * @param {string} id
     * @returns BitId
     */

  }, {
    key: 'fromBitId',
    value: function fromBitId(id) {
      var parsed = bitIdRegex.exec(id);
      if (!parsed) return undefined;

      var _parsed2 = _slicedToArray(parsed, 7),
          //match 0
      owner = _parsed2[1],
          //group 1
      scope = _parsed2[2],
          //group 2
      box = _parsed2[4],
          //group 3, group 4
      version = _parsed2[6];

      var fullName = (box || '').split('/');
      return new BitId(owner, scope, fullName, version);
    }
  }]);

  return BitId;
}();

module.exports = BitId;